import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import * as React from "react";
import { styled } from "@mui/system";
import { getDataGridUtilityClass } from "../../constants/gridClasses.es.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { useGridAriaAttributes } from "../../hooks/utils/useGridAriaAttributes.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import composeClasses from "../../../utils/composeClasses/composeClasses.es.js";
const useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["main"]
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridMainContainerRoot = styled("div", {
  name: "MuiDataGrid",
  slot: "Main",
  overridesResolver: (props, styles) => styles.main
})(() => ({
  position: "relative",
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
}));
const GridMainContainer = /* @__PURE__ */ React.forwardRef((props, ref) => {
  var _rootProps$experiment;
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses(rootProps);
  const getAriaAttributes = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 ? useGridAriaAttributes : null;
  const ariaAttributes = typeof getAriaAttributes === "function" ? getAriaAttributes() : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridMainContainerRoot, _extends({
    ref,
    className: classes.root,
    ownerState: rootProps
  }, ariaAttributes, {
    children: props.children
  }));
});
export {
  GridMainContainer
};
//# sourceMappingURL=GridMainContainer.es.js.map
